/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export const useResultadosAnalise = () => {
  const url = `${backofficeEnviroment}/common/backoffice/resultados-analise/v1`;

  const fetchData = async () => {
    const response = await instance.get(url);
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-resultados-analise"],
    refetchOnWindowFocus: false,
  });

  return query;
};
